import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translate } from 'react-translate';
import { useFileUtils } from 'hooks';

const ChatStatus = () => {
  const practitioner = useSelector(state => state.practicesReducer.userInfo);
  const user = useSelector((state) => state.userReducer);
  const { getAvatar, defaultImage } = useFileUtils();

  useEffect(() => {
    getAvatar(user.avatar, 'large', true);
    //eslint-disable-next-line
  }, [user.avatar, user.updated_at, practitioner]);


  if (!Object.keys(practitioner).length) {
    return <></>;
  }
  return (
    <div className="chat_profile d-flex align-items-center justify-content-end pull-right">
      {user.avatar ? (
        <img src={defaultImage} alt="Contact" id="user-avatar" />
      ) : (
        <span className="avatar-name">{practitioner.nameInitials.toUpperCase()}</span>
      )}
      <div className={`avatar-status ${practitioner.status}`}></div>
    </div>
  );
};

export default translate('chat')(React.memo(ChatStatus));
